import TimeFrameField from '@apps/truevail/admin/components/timeframefield'
import SocialSchedulingToken from './social_scheduling'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Scheduling extends React.PureComponent {

  static propTypes = {
    formdata: PropTypes.object,
    onBack: PropTypes.func,
    onCancel: PropTypes.func,
    onChange: PropTypes.func,
    onNext: PropTypes.func,
    onSave: PropTypes.func
  }

  formRef = React.createRef()

  _handleBack = this._handleBack.bind(this)
  _handleChange = this._handleChange.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  constructor(props) {
    super(props)
    this.state = {
      config: props.formdata || {}
    }
  }

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { config } = this.state
    return {
      ref: this.formRef,
      showHeader: false,
      buttons: [
        { 
          label: 't(Previous)',
          color: 'blue',
          basic: true,
          handler: this._handleBack 
        },
        { 
          label: 't(Done)',
          color: 'blue',
          handler: this._handleSubmit 
        }
      ],
      onChange: this._handleChange,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            {
              label: 't(Scheduling)',
              instructions: 't(Choose preferred method of your social campaign scheduling. You will always receive a preview of your monthly content approx. one week before the beginning of the calendar month)',               type: 'segment',
              fields: [
                { 
                  name: 'social_scheduling',
                  type: 'radiogroup',
                  options: ['optout','optin'],
                  defaultValue: config.social_scheduling || 'optout',
                  format: SocialSchedulingToken,
                  required: true 
                },
                { 
                  label: 't(Timeframe)',
                  instructions: 't(Specify any timeframes for us to schedule your posts. Post will be randomly scheduled during the times set)',
                  name: 'social_timeframe',
                  type: TimeFrameField,
                  show: config.social_scheduling === 'optout',
                  defaultValue: config.social_timeframe,
                  required: true 
                }
              ]
            }
          ]
        }
      ]
    }
  }

  _handleBack() {
    this.props.onBack()
  }

  _handleChange(config) {
    this.setState({ config })
  }

  _handleSubmit() {
    this.formRef.current.submit()
  }

  _handleSuccess(config) {
    const { formdata } = this.props
    this.props.onSave({
      ...formdata,
      ...config
    })
  }

}

export default Scheduling
